module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r3r4r8n-c87e04acb95f8659c18c4cca6a2a6644.svg";